import React, { useEffect } from 'react';
import { CheckCircle, XCircle, X } from 'lucide-react';
import './styles/popup.css';

const Popup = ({ 
  type = 'success', 
  message, 
  onClose,
  duration = 5000,
  className 
}) => {
  useEffect(() => {
    if (duration) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  return (
    <div 
      className={`popup-container ${type} ${className || ''}`}
      role="alert"
      aria-live="polite"
    >
      <div className="popup-content">
        <div className="popup-icon">
          {type === 'success' ? (
            <CheckCircle size={24} strokeWidth={2} color="#3e9392" />
          ) : (
            <XCircle size={24} strokeWidth={2} color="#dc2626" />
          )}
        </div>
        <div className="popup-message">{message}</div>
        <button 
          className="popup-close"
          onClick={onClose}
          aria-label="Close notification"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default Popup;